import {Component} from '@angular/core';
import {ComparePrintHeaderComponent} from './compare-print-header/compare-print-header.component';
import {ComparePrintItemsComponent} from './compare-print-items/compare-print-items.component';
import {ComparePrintFooterComponent} from './compare-print-footer/compare-print-footer.component';

@Component({
  selector: 'app-compare-print',
  imports: [
    ComparePrintHeaderComponent,
    ComparePrintItemsComponent,
    ComparePrintFooterComponent
  ],
  templateUrl: './compare-print.component.html',
  styleUrl: './compare-print.component.css',
})
export class ComparePrintComponent {
}
